import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiStatics } from "../../Utils/constants";
import { expireTokenHandler } from "../../Utils/helpers";

export const getDashStats = createAsyncThunk(
  `dashboard/getDashStats`,
  async ({ navigate }) => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
          // Accept: "*/*",
        },
      };
      let response = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.dashboard.dashboard}/${ApiStatics.dashboard.stats}`,
        config
      );

      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      console.log("error", error);
      //   toast.error(error.response.data.message);
      expireTokenHandler(error.response.data.message, navigate);
      return {
        success: false,
        error: error.message,
      };
    }
  }
);

export const updateCandidateRequest = createAsyncThunk(
  `dashboard/updateCandidateRequest`,
  async ({ requestId, values, toast }) => {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
        // Accept: "*/*",
      },
    };
    try {
      let response = await axios.patch(
        `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.auth.auth}/${ApiStatics.userTypes.candidate}/${ApiStatics.requests.requests}/${requestId}`,
        values,
        config
      );
      console.log("response", response);
      toast.success("Details updated successfully");
      setTimeout(() => {
        window.location.reload();
      }, 2500);
      return {
        success: true,
      };
    } catch (error) {
      //   toast.error(error.response.data.message);
      console.log("error", error);
      const status = error.response.status;
      expireTokenHandler(status);
      return {
        success: false,
        // error: error.message,
      };
    }
  }
);
export const updateCandidatePreference = createAsyncThunk(
  `dashboard/updateCandidatePreference`,
  async ({ candidateId, values, toast, status, dispatch }) => {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
        // Accept: "*/*",
      },
    };
    try {
      let response = await axios.patch(
        `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.profile.profile}/${ApiStatics.userTypes.candidate}/${candidateId}/${ApiStatics.profile.preferences}`,
        values,
        config
      );
      console.log("response", response);
      toast.success("Details updated successfully");

      console.log("status received", status);
      if (status && status === "approved") {
        await axios.patch(
          `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.profile.profile}/${ApiStatics.userTypes.candidate}/${candidateId}`,
          { verified: true },
          config
        );
      }
      setTimeout(() => {
        window.location.reload();
      }, 4000);
      return {
        success: true,
      };
    } catch (error) {
      //   toast.error(error.response.data.message);
      console.log("error", error);
      const status = error.response.status;
      expireTokenHandler(status);
      return {
        success: false,
        // error: error.message,
      };
    }
  }
);
export const getAllExperienceLevels = createAsyncThunk(
  `dashboard/getAllExperienceLevels`,
  async ({ experienceNameHandler, name, page, limit }) => {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
        // Accept: "*/*",
      },
    };
    try {
      let response = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.jobs.jobs}/${ApiStatics.jobs.experience}`,
        config
      );

      console.log("cat fetxh", response.data.data.data);
      experienceNameHandler && experienceNameHandler(response.data.data.data);
      return {
        success: true,
        data: response.data.data.data,
        total: response.data.total,
      };
    } catch (error) {
      //   toast.error(error.response.data.message);
      console.log("error", error);
      const status = error.response.status;
      expireTokenHandler(status);
      return {
        success: false,
        // error: error.message,
      };
    }
  }
);
export const getAllJobFunctions = createAsyncThunk(
  `dashboard/getAllJobFunctions`,
  async ({ jobFunctionNameHandler, name, page, limit }) => {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
        // Accept: "*/*",
      },
    };
    try {
      let response = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.jobs.jobs}/${ApiStatics.jobs.functions}/?randomOrder=true`,
        config
      );

      console.log("cat fetxh", response.data.data.data);
      jobFunctionNameHandler && jobFunctionNameHandler(response.data.data.data);
      return {
        success: true,
        data: response.data.data.data,
        total: response.data.total,
      };
    } catch (error) {
      //   toast.error(error.response.data.message);
      console.log("error", error);
      const status = error.response.status;
      expireTokenHandler(status);
      return {
        success: false,
        // error: error.message,
      };
    }
  }
);
const initialState = {
  stats: {},
  dashboardLoading: false,
  updatedLoading: false,
  error: {
    result: false,
    message: "",
  },
  success: false,
};

const DashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashStats.pending, (state) => {
        state.dashboardLoading = true;
        state.error = initialState.error;
      })
      .addCase(getDashStats.fulfilled, (state, { payload }) => {
        state.dashboardLoading = false;
        state.stats = payload.data;
        state.success = true;
      });
    builder
      .addCase(getAllExperienceLevels.fulfilled, (state, action) => {
        let { data, total } = action.payload;
        state.loading = false;
        state.experiences = data;
        state.success = true;
        state.total = total;
      })
      .addCase(getAllExperienceLevels.pending, (state, action) => {
        state.loading = true;
        state.error = initialState.error;
      })
      .addCase(getAllExperienceLevels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(updateCandidateRequest.fulfilled, (state, action) => {
        state.updatedLoading = false;
        state.success = true;
      })
      .addCase(updateCandidateRequest.pending, (state, action) => {
        state.updatedLoading = true;
        state.error = initialState.error;
      })
      .addCase(updateCandidateRequest.rejected, (state, action) => {
        state.updatedLoading = false;
        state.error = action.payload;
      });
    builder
      .addCase(updateCandidatePreference.fulfilled, (state, action) => {
        state.updatedLoading = false;
        state.success = true;
      })
      .addCase(updateCandidatePreference.pending, (state, action) => {
        state.updatedLoading = true;
        state.error = initialState.error;
      })
      .addCase(updateCandidatePreference.rejected, (state, action) => {
        state.updatedLoading = false;
        state.error = action.payload;
      });
    builder
      .addCase(getAllJobFunctions.fulfilled, (state, action) => {
        let { data, total } = action.payload;
        state.loading = false;
        state.jobFunctions = data;
        state.success = true;
        state.total = total;
      })
      .addCase(getAllJobFunctions.pending, (state, action) => {
        state.loading = true;
        state.error = initialState.error;
      })
      .addCase(getAllJobFunctions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default DashboardSlice.reducer;
export const {} = DashboardSlice.actions;
